<template>
  <div>
    <topup-form />
  </div>
</template>

<script>
import TopupForm from '../components/Topup/Form'

export default {
  name: 'TopupView',
  components: {
    TopupForm
  }
}
</script>
